import { render, staticRenderFns } from "./DropImages.vue?vue&type=template&id=ddc5c980&"
import script from "./DropImages.vue?vue&type=script&lang=ts&"
export * from "./DropImages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports